import React, { useState, useEffect } from 'react';
import { useSnackbar } from 'notistack';
import { Button, Grid, Paper, Tab, Table, TableBody, Tabs } from '@material-ui/core';
import { ImportFleet, AddAssembly, FleetHeader, FleetList, CompareLogs } from '../components';
import { FilterComponent, Pagination, PageLoader, EmptyCollection, DeletePopUp } from '../../../shared_elements'
import { STableLoader } from '../../../shared_elements/loaders';
import DateRangeIcon from '@material-ui/icons/DateRange';
import { globalGetService, globalPostService, globalDeleteService, globalExportService, globalPutService } from '../../../utils/globalApiServices';
import { checkApiStatus, downloadFileType, getLocalStorageInfo, onCheckPermission, removeEmptyKey } from '../../../utils';
import { fleetFilters, addAssemblyObj } from '../'
import ViewListIcon from '@material-ui/icons/ViewList';
import CalanderView from '../components/CalanderView';
import BarChartIcon from '@material-ui/icons/BarChart';
import SaveAltIcon from '@material-ui/icons/SaveAlt';
import AddIcon from '@material-ui/icons/Add';
import moment from 'moment';
import FleetPortfolioGraphs from '../components/FleetPortfolioGraphs';
import DeploymentMessage from '../../../shared_elements/components/DeploymentMessage';
const Fleet = ({ params }) => {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [isLoading, setLoading] = useState(false);
    const [toggleView, setToggleView] = useState('list');
    const [calYearMenu, setCalYearMenu] = useState([]);
    const [calPaginationdata, setCalPaginationdata] = useState([]);
    const [calQuerry, setCalQuerry] = useState({});
    const [selectedYear, setSelectedYear] = useState('')
    const [calViewMode, setCalViewMode] = useState(0);
    const [calenderData, setCalenderData] = useState([]);
    const [tabIndex, setTabIndex] = useState('airframe');
    const [skeletonLoader, setSkeletonLoader] = useState(false)
    const [filter, setFilter] = useState({});
    const [addEditAssembly, setAddEditAssembly] = useState({ modal: false, mode: '', assemblyType: '', data: null })
    const [assemblyInfo, setAssemblyInfo] = useState({ list: [], pagination: {} });
    const [addEditPortFolio, setAddEditPortFolio] = useState({ modal: false, mode: '', data: null })
    const [selectedAssets, setSelectedAssets] = useState([])
    const [compareLogs, setCompareLogs] = useState({ modal: false, data: [] })
    const [deleteAssembly, setDeleteAssembly] = useState({ modal: false, data: null })
    useEffect(() => {
        getAssemblyInfo({ ...filter, asset: tabIndex }, 'skeletonLoader');
    }, []);
    const onCalanderItemClick = (data) => {
        setLoading(true)
        globalGetService(`new-mr-calculator/fleet-portfolio-list/?module_type=fleet-level&asset=${data?.asset}&id=${data.id}`)
            .then(response => {
                setLoading(false)
                setTabIndex(data?.asset)
                setAddEditAssembly({ modal: true, mode: 'edit', assemblyType: data?.asset, data: response?.data.data })
            })
    }
    const getAssemblyInfo = (query = {}, loaderType) => {
        loaderType === 'skeletonLoader' ? setSkeletonLoader(true) : setLoading(true);
        globalGetService(`new-mr-calculator/fleet-portfolio-list/`, { ...query, module_type: 'fleet-level' })
            .then(response => {
                if (checkApiStatus(response)) {
                    setAssemblyInfo(response.data.data);
                    delete query.page
                    delete query.per_page
                    delete query.asset
                    setFilter(query)
                }
                loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false);
            })
    }
    const onAssetSelection = (flag, id) => {
        if (flag && selectedAssets.length < 10) {
            setSelectedAssets([...selectedAssets, id])
        }
        else {
            if (selectedAssets?.length == 10 && flag) {
                enqueueSnackbar('Maximum selection limit reached. You can select up to 10 logs. ', { variant: 'error', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
            }
            setSelectedAssets(selectedAssets.filter(item => item !== id))
        }
    }
    const onCompareLogs = () => {
        setLoading(true)
        globalGetService('new-mr-calculator/fleet-portfolio-list/', { module_type: 'fleet-level', asset: tabIndex, compare_logs: selectedAssets.join(',') })
            .then(response => {
                if (checkApiStatus(response)) {
                    setCompareLogs({ modal: true, data: response.data.data })
                }
                setLoading(false)
            })
    }

    const onExportCompareReport = (query = {}) => {
        setLoading(true);
        globalExportService(`new-mr-calculator/fleet-portfolio-list/`, { ...query, compare_logs: selectedAssets.join(','), asset: tabIndex, module_type: 'fleet-level', download: 'xlsx' })
            .then(response => {
                downloadFileType(response.data, 'Fleet_Level_Comparision_Export', 'xlsx');
                setLoading(false);
            })
    }
    const onExportReport = (query = {}) => {
        setLoading(true);
        globalExportService(`new-mr-calculator/fleet-portfolio-list/`, { ...query, module_type: 'fleet-level', download: 'xlsx' })
            .then(response => {
                downloadFileType(response.data, 'Fleet_Level_Export', 'xlsx');
                setLoading(false);
            })
    }
    const onDeleteAssembly = () => {
        setLoading(true)
        globalDeleteService(`new-mr-calculator/fleet-portfolio/`, { module_type: 'fleet-level', id: [deleteAssembly.data.id] })
            .then(response => {
                if (checkApiStatus(response)) {
                    setDeleteAssembly({ modal: false, data: null })
                    getAssemblyInfo({ ...filter, asset: tabIndex }, 'pageLoader');
                    enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
                } else {
                    enqueueSnackbar(response.data.message, { variant: 'error', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
                }
                setLoading(false)
            })
    }
    const getCalanderData = (query) => {
        setCalQuerry(query)
        setLoading(true)
        setToggleView('calender')
        globalGetService(`new-mr-calculator/fleet-calendar-view/`, query)
            .then(response => {
                if (query.year_view) {
                    setCalViewMode(1)
                }
                else if (query?.month_view) {
                    setSelectedYear(query?.month_view == true ? { label: moment().format('YYYY'), value: moment().format('YYYY') } : { label: query?.month_view, value: query?.month_view })
                    setCalViewMode(0)
                }
                setLoading(false)
                let minYear = response.data.data.pagination_data?.min_year
                let maxYear = response.data.data.pagination_data?.max_year
                let yearMenu = []
                for (let i = minYear; i <= maxYear; i++) {
                    yearMenu.push({ label: i.toString(), value: i.toString() })
                }
                setCalYearMenu(yearMenu)
                setCalPaginationdata(response.data.data?.pagination_data)
                setCalenderData(response.data.data)
            })
    }
    let filterOptions = Object.assign({}, fleetFilters);
    return (
        <section className='portfolio-fleet-section' style={{minHeight:`${window.innerHeight - 135}px`}}>
            <DeploymentMessage />
            {skeletonLoader ? <STableLoader count={8} size={9} /> :
                <>
                    <div className='fleet-tabs'>
                        <Grid container spacing={1} alignItems='center'>
                            <Grid item xs={12} sm={12} md={8}>
                                {
                                    toggleView !=='list' ? null :
                                        <Paper>
                                            <Tabs indicatorColor='primary' value={tabIndex} onChange={(event, newValue) => { setTabIndex(newValue); getAssemblyInfo({ ...filter, asset: newValue }, 'pageLoader'); setSelectedAssets([]) }} variant='fullWidth'>
                                                <Tab disabled={toggleView !=='list'} label="Airframe" value='airframe' />
                                                <Tab disabled={toggleView !=='list'} label="Engines" value='engines' />
                                                <Tab disabled={toggleView !=='list'} label="APU" value='apu' />
                                                <Tab disabled={toggleView !=='list'} label="Landing Gears" value='lg' />
                                            </Tabs>
                                        </Paper>
                                }
                            </Grid>
                            <Grid item xs={12} sm={12} md={4}>
                                <ul className="list-inline flex-centered" style={{ float: 'right', marginTop: toggleView != 'list' ? '8px' : '0px' }}>
                                    <li className='list-inline-item' style={{ marginLeft: "10px" }}>
                                        <span className='list-analytic-sw' style={{width:'120px'}}>
                                            <span className={toggleView == 'list'? 'active':''}>
                                                <ViewListIcon color={toggleView == 'list' ?  'primary': 'default'} onClick={() => setToggleView('list')} />
                                            </span>
                                            <span style={{borderRight:"1px solid #cdcdcd", borderLeft:"1px solid #cdcdcd"}} className={toggleView == 'calender'? 'active':''}>
                                                <DateRangeIcon color={toggleView == 'calender'?  'primary': 'default'} onClick={() => { setToggleView('calender'); getCalanderData({ year_view: true }); setCalViewMode(1) }} />
                                            </span>
                                            <span className={toggleView == 'graph'? 'active':''}>
                                                <BarChartIcon onClick={() => {setToggleView('graph')}} color={toggleView == 'graph' ? 'primary' : 'default'} />
                                            </span>
                                        </span>
                                    </li>
                                    <li className='list-inline-item'>
                                        <ImportFleet
                                            getResponseBack={() => getAssemblyInfo({ ...filter, page: 1, asset: tabIndex }, 'pageLoader')}
                                        />
                                    </li>
                                    <li className='list-inline-item'>
                                        <Button disabled={selectedAssets.length > 1 ? false : true} onClick={() => onCompareLogs()} color='primary' size='small' variant='contained'>Compare Log</Button>
                                    </li>
                                </ul>
                            </Grid>
                        </Grid>
                    </div>
                    {
                        toggleView == 'calender' ?
                            <Paper className='fleet-filter-div' square>
                                <CalanderView
                                    calQuerry={calQuerry}
                                    onCalanderItemClick={onCalanderItemClick}
                                    calPaginationdata={calPaginationdata}
                                    selectedYear={selectedYear}
                                    calYearMenu={calYearMenu}
                                    calenderData={calenderData}
                                    calViewMode={calViewMode}
                                    getCalanderData={getCalanderData} />
                            </Paper>
                            :
                            toggleView == 'graph' ?
                            <div>
                                <FleetPortfolioGraphs 
                                module={'fleet'}
                                />
                            </div> :
                            <>
                                <Paper className='fleet-filter-div' square>
                                    <Grid container spacing={1}>
                                        <Grid item md={8} xs={3}>
                                            <FilterComponent
                                                filter={filter}
                                                filterMenu={filterOptions}
                                                getResponseBack={(applyFilter) => getAssemblyInfo({ ...applyFilter, page: 1, per_page: assemblyInfo.pagination.per_page, asset: tabIndex }, 'pageLoader')}
                                            />
                                        </Grid>
                                        <Grid item md={4} xs={9}>
                                            <ul className='list-inline'>
                                                 {assemblyInfo.list.length ?
                                                    <li className='list-inline-item'>
                                                        <Button color='primary' size='small' variant='outlined' onClick={() => onExportReport({ asset: tabIndex })}><SaveAltIcon style={{fontSize:'1.15rem',marginInlineEnd:'2px'}}/>Export</Button>
                                                    </li> : null
                                                }
                                                {
                                                    onCheckPermission('mr_calculator', 'fleet_data', 'C') ?
                                                        <li className='list-inline-item'>
                                                            <Button onClick={() => setAddEditAssembly({ modal: true, mode: 'add', assemblyType: tabIndex, data: addAssemblyObj })} color='primary' size='small' variant='contained'><AddIcon style={{ fontSize: '1.15rem' }} />Add Assembly</Button>
                                                        </li>
                                                        : null}
                                            </ul>
                                        </Grid>
                                    </Grid>
                                </Paper>
                                <Paper>
                                    <Paper className='fleet-log-section' style={tabIndex ? {maxHeight: window.innerHeight - 290 + 'px', overflow: 'scroll' } : {}}>
                                        <Table className={`mui-styled-table fleet-log-listing  ${tabIndex ? 'engine-log-list' : ''}`} style={tabIndex ? { width: 'max-content', minWidth: "100%" } : {}}>
                                            <FleetHeader tabIndex={tabIndex} />
                                            <TableBody>
                                                {assemblyInfo.list.map((item, itemIndex) =>
                                                    <FleetList
                                                        tab={'fleet_data'}
                                                        item={item}
                                                        tabIndex={tabIndex}
                                                        selectedAssets={selectedAssets}
                                                        onAssetSelection={onAssetSelection}
                                                        onEdit={() => setAddEditAssembly({ modal: true, mode: 'edit', data: item })}
                                                        onDelete={() => setDeleteAssembly({ modal: true, data: item })}
                                                    />
                                                )}
                                            </TableBody>
                                        </Table>
                                    </Paper>
                                    <Paper>
                                    <Pagination
                                        pagination={assemblyInfo.pagination}
                                        onChangePage={(event, newPage) => getAssemblyInfo({ page: newPage + 1, per_page: assemblyInfo.pagination.per_page, asset: tabIndex }, 'pageLoader')}
                                        onChangeRowsPerPage={(event) => getAssemblyInfo({ page: 1, per_page: event.target.value, asset: tabIndex }, 'pageLoader')}
                                    />
                                    </Paper>
                                    {assemblyInfo.list.length ? null : <EmptyCollection />}
                                </Paper>
                            </>
                    }
                </>
            }
            {addEditAssembly.modal ?
                <AddAssembly
                    calQuerry={calQuerry}
                    tabIndex={tabIndex}
                    addEditAssembly={addEditAssembly}
                    getResponseBack={() => { getAssemblyInfo({ ...filter, asset: tabIndex, page: 1 }, 'pageLoader'); toggleView == 'calender' ? getCalanderData(calQuerry) : console.log() }}
                    toggleModalFn={() => setAddEditAssembly({ modal: false, mode: '', assemblyType: '', data: null })}
                    addEditModuleType='fleet-level'
                /> : null
            }
            {compareLogs.modal ?
                <CompareLogs
                    onExportCompareReport={onExportCompareReport}
                    compareLogs={compareLogs}
                    toggleModalFn={() => setCompareLogs({ modal: false, data: [] })}
                /> : null
            }
            {deleteAssembly.modal ?
                <DeletePopUp
                    modal={deleteAssembly.modal}
                    toggleModalFn={() => setDeleteAssembly({ modal: false, data: null })}
                    title="Delete Assembly"
                    content={<h4>Are you sure you want to delete?</h4>}
                    deleteRecordFn={onDeleteAssembly}
                /> : null
            }
            {isLoading ? <PageLoader /> : null}
        </section>
    )
}
export default Fleet;